module.exports = __webpack_public_path__ + "img/日历签到1.e65b7866.png";